export default {
  props: {
    modalId: {type: String, default: 'modal'},
  },

  methods: {

    /**
     * Show modal dialog.
     */
    showModal() {
      this.$modal.show(this.modalId);
    },

    /**
     * Hide modal dialog.
     */
    hideModal() {
      this.$modal.hide(this.modalId);
    },

  }
}
